import styled from "@emotion/styled";
import { useState } from "react";
import { theme } from "styles/theme";

type TRadioButton = {
    label?: string;
    active?: boolean;
    onClick?: () => void;
};

const RadioContainer = styled.div`
    display: flex;
    gap: 8px;
`;

const RadioLabel = styled.p`
    color: ${theme.neutral900};
    font-size: 16px;
    font-weight: 500;
`;

const RadioButton = (props: TRadioButton) => {
    const { label, active, onClick } = props;

    return (
        <RadioContainer onClick={onClick}>
            {active ? <ActiveRadioButton /> : <UnActiveRadioButton />}
            <RadioLabel>{label}</RadioLabel>
        </RadioContainer>
    );
};

const ActiveRadioButton = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="9.16667" fill="white" stroke="#3885FF" stroke-width="1.66667" />
            <circle cx="9.9974" cy="9.99935" r="5.83333" fill="#3885FF" />
        </svg>
    );
};

const UnActiveRadioButton = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <circle cx="10" cy="10" r="9.5" fill="#EBF5FF" stroke="#DCEEFF" />
        </svg>
    );
};

export default RadioButton;
